import { render, staticRenderFns } from "./_base-sidebar.vue?vue&type=template&id=0d4cef44&scoped=true&"
import script from "./_base-sidebar.vue?vue&type=script&lang=js&"
export * from "./_base-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./_base-sidebar.vue?vue&type=style&index=0&id=0d4cef44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4cef44",
  null
  
)

export default component.exports